export default __webpack_public_path__ + "media/images/temporary/story-2-e51a51a90056abcf925778283f92ea3d.jpg";